import { Monitor, Moon, Sun } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useTheme, type Theme } from "@/lib/theme";

const ORDER: Theme[] = ["system", "light", "dark"];

const CONFIG: Record<Theme, { icon: typeof Sun; label: string }> = {
  system: { icon: Monitor, label: "Systemets tema" },
  light: { icon: Sun, label: "Ljust tema" },
  dark: { icon: Moon, label: "Mörkt tema" },
};

/** Cycles system → light → dark. */
export function ThemeToggle() {
  const { theme, setTheme } = useTheme();
  const { icon: Icon, label } = CONFIG[theme];
  const next = ORDER[(ORDER.indexOf(theme) + 1) % ORDER.length] ?? "system";

  return (
    <Button
      variant="ghost"
      size="icon-sm"
      onClick={() => setTheme(next)}
      title={`${label} — klicka för ${CONFIG[next].label.toLowerCase()}`}
      aria-label={`${label}. Byt till ${CONFIG[next].label.toLowerCase()}`}
    >
      <Icon className="h-4 w-4" />
    </Button>
  );
}
